import React from 'react';

const SkeletonBlock = ({ className }) => (
  <div className={`animate-pulse rounded-xl bg-muted ${className}`} aria-hidden="true" />
);

const RolloutCatalogSkeleton = ({ count = 6 }) => (
  <div className="space-y-3" aria-hidden="true">
    {Array.from({ length: count }).map((_, index) => (
      <div
        key={`rollout-skeleton-${index + 1}`}
        className="grid gap-4 rounded-xl border border-border/40 bg-card/20 px-4 py-4 md:grid-cols-[minmax(0,1.55fr)_minmax(0,1.2fr)_minmax(150px,0.8fr)_minmax(120px,0.65fr)_minmax(170px,0.9fr)_minmax(170px,0.9fr)] md:items-center"
      >
        <div className="space-y-2">
          <SkeletonBlock className="h-4 w-36" />
          <SkeletonBlock className="h-3 w-28" />
        </div>
        <SkeletonBlock className="h-10 w-full" />
        <SkeletonBlock className="h-10 w-full" />
        <SkeletonBlock className="h-10 w-24" />
        <div className="flex gap-2">
          <SkeletonBlock className="h-9 w-16" />
          <SkeletonBlock className="h-9 w-16" />
        </div>
        <div className="flex gap-2">
          <SkeletonBlock className="h-9 w-20" />
          <SkeletonBlock className="h-9 w-9" />
        </div>
      </div>
    ))}
  </div>
);

export default RolloutCatalogSkeleton;

